<ion-item
  class="ion-align-items-start"
  [class.user-disabled]="!user().enabled"
>
  <ion-label>
    <ion-grid class="ion-no-padding">
      <ion-row>
        <ion-col
          size-lg="6"
          size="12"
          class="user-main"
        >
          <p class="user-name">
            @if (isCurrentUser()) {
              <ion-badge color="success">{{ 'users.you' | translate }}</ion-badge>
            }
            @if (!canRemove()) {
              <ion-badge color="warning"
                ><ion-icon
                  aria-hidden="true"
                  src="../assets/material-symbols/lock_person_24dp.svg"
                ></ion-icon
              ></ion-badge>
            }
            <span>{{ user().firstName }} {{ user().lastName }}</span>
          </p>
          <p class="fs-xs">
            <strong>{{ user().email }}</strong>
          </p>
          <p class="fs-xs">
            <strong>{{ user().phone }}</strong>
          </p>
        </ion-col>
        <ion-col
          size-lg="6"
          size="12"
        >
          <div>
            @if (!user().enabled) {
              <ion-badge color="medium">{{ 'general.disabled' | translate }}</ion-badge>
            }
          </div>
          @for (role of user().roles; track role) {
            <div>
              <ion-badge color="primary">{{ roleLabelKey(role) | translate }}</ion-badge>
            </div>
          }
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-label>

  <lib-user-delete-action
    slot="end"
    [user]="user()"
    [canRemove]="canRemove()"
  ></lib-user-delete-action>

  <lib-user-edit-action
    slot="end"
    [user]="user()"
  ></lib-user-edit-action>
</ion-item>
